import React from 'react';
import { Icon } from '@iconify/react';

interface InputFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  icon?: string;
  error?: string;
  fullWidth?: boolean;
}

const InputField: React.FC<InputFieldProps> = ({ label, icon, error, fullWidth = true, style, ...rest }) => {
  const containerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    width: fullWidth ? '100%' : undefined,
  };

  const inputWrapperStyle: React.CSSProperties = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    background: 'var(--input-bg)',
    backdropFilter: 'blur(8px)',
    border: `1px solid ${error ? 'var(--danger)' : 'var(--input-border)'}`,
    borderRadius: 'var(--radius-md)',
    padding: icon ? '10px 14px 10px 40px' : '10px 14px',
    color: 'var(--input-text)',
    fontFamily: 'var(--font-body)',
    fontSize: '14px',
    outline: 'none',
    transition: 'all var(--transition-base)',
    ...style,
  };

  return (
    <div style={containerStyle}>
      {label && (
        <label style={{
          fontSize: '12px',
          fontWeight: 600,
          color: 'var(--text-muted)',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        }}>
          {label}
        </label>
      )}
      <div style={inputWrapperStyle}>
        {icon && (
          <Icon
            icon={icon}
            width={18}
            style={{
              position: 'absolute',
              left: '12px',
              color: 'var(--text-muted)',
              pointerEvents: 'none',
            }}
          />
        )}
        <input style={inputStyle} {...rest} />
      </div>
      {error && (
        <span style={{ fontSize: '12px', color: 'var(--danger)' }}>{error}</span>
      )}
    </div>
  );
};

export default InputField;
